import { HttpContextToken } from '@angular/common/http';

/**
 * Request-scoped flag to opt a call out of the global loader.
 * Set to true to suppress the spinner (e.g. background/polling/typeahead calls).
 * Read by the loadingInterceptor; being context (not a header) it never reaches the server.
 */
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

/**
 * Request-scoped flag to opt a call out of the global 401/403 redirect to `/unauthorized`.
 * Set to true for calls whose auth failure should not take the whole page down; a notification
 * is shown instead and the error is rethrown so the caller can handle it.
 * Read by the errorInterceptor; being context (not a header) it never reaches the server.
 */
export const SKIP_ERROR_PAGE = new HttpContextToken<boolean>(() => false);
